import { ComponentType, lazy } from 'react';

/**
 * Utility to create lazy-loaded components with named exports
 */
export function createLazyComponent<
  T extends ComponentType<any> = ComponentType<any>,
>(importFn: () => Promise<{ [key: string]: T }>, exportName: string) {
  return lazy(() =>
    importFn().then((module) => ({
      default: module[exportName as keyof typeof module] as T,
    })),
  );
}
